module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-t-mobile-03.00653ee8.jpg";